import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import generoPessoa from "@/models/enum/generosPessoa";
import tipoConselhoRegional from "@/models/enum/tipoConselhoRegional";
import ufs from "@/models/enum/ufs";
import PrescritorModel from "@/models/prescritorModel";
import CidadeService from "@/services/external/cidadeService";
import PrescritorService from "@/services/prescritorService";
import Delay from "@/utils/common/delay";

import ShortcutComponent from "../../shortcut/shortcut";
import shortcutComponent from "../../shortcut/shortcut.vue";
import ListComponentBase from "../listComponentBase";

import verComponent from "./ver.vue";

import "../crud.scss";

@Component({
    components: {
        shortcutComponent,
        verComponent,
    },
})
export default class PrescritorListComponent extends ListComponentBase<PrescritorModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("id", "Código", GridColumnType.Integer),
            new GridColumn("nome", "Nome", GridColumnType.String),
            new GridColumn("email", "Email", GridColumnType.String),
            new GridColumn("telefone", "Telefone", GridColumnType.String),
            new GridColumn("numeroRegistro", "Número de Registro", GridColumnType.String),
            new GridColumn("tipoConselhoRegionalDescricao", "Conselho Regional", GridColumnType.String),
            new GridColumn("ufConselhoRegionalDescricao", "UF do Conselho", GridColumnType.String),
            new GridColumn("sipeAgro", "SipeAgro", GridColumnType.String),
            new GridColumn("especialidadesDescricao", "Especialidades", GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setProps(new PrescritorService(), "prescritor", "nome");
    }

    private cidadeService = new CidadeService();
    private shortcutComponent: ShortcutComponent = null;

    extraActions: Array<object> = [];
    private gridExtraActionsVer: Array<GridAction> = [];
    private gridExtraActionsWhatsapp: Array<GridAction> = [];
    modelVer: PrescritorModel | null = null;
    showVer = false;

    private actionNameVer = "ver";
    private actionNameWhatsapp = "whatsapp";

    public async afterLoad() {
        this.gridExtraActionsWhatsapp.splice(0);
        this.gridExtraActionsVer.splice(0);
        this.extraActions.splice(0);

        for (const prescritor of this.gridData as PrescritorModel[]) {
            this.gridExtraActionsWhatsapp.push(
                new GridAction(
                    this.actionNameWhatsapp,
                    this.$t("__.Components.parent.crud.prescritor.list_vue_html.chamarWhatsapp") as string,
                    "fab fa-whatsapp fa-2x",
                    GridColors.GREEN,
                    prescritor.celular != null && prescritor.celular?.trim() !== "",
                ),
            );

            this.gridExtraActionsVer.push(
                new GridAction(this.actionNameVer, "Ver Prescritor", "fa fa-eye", GridColors.BLUE, true),
            );
        }

        this.extraActions.push(this.gridExtraActionsWhatsapp);
        this.extraActions.push(this.gridExtraActionsVer);
    }

    private async onExtraAction(name: string, model: PrescritorModel) {
        if (name.trim() == this.actionNameVer) {
            this.onVer(model);
        }
        if (name.trim() == this.actionNameWhatsapp) {
            window.open(`https://wa.me/${model.celular}`, "_blank");
        }
    }

    private async onVer(prescritor: PrescritorModel) {
        while (!this.$refs.shortcutComponent) await Delay(5);
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = "Prescritor";

        try {
            const data = await this.service.get(prescritor.id!).withLoading().resolveWithJSON<PrescritorModel>();
            this.modelVer = data;

            if (data.estadoId) {
                const cidades = await this.cidadeService.get(data.estadoId).withLoading();
                if (cidades.some(p => p.value == this.modelVer?.cidadeId)) {
                    this.modelVer.cidadeDescricao = cidades.find(p => p.value == this.modelVer.cidadeId)["text"];
                }
                this.modelVer.tipoConselhoRegionalDescricao = EnumExtensions.getNameByValue(
                    tipoConselhoRegional,
                    data.tipoConselhoRegional,
                );
                this.modelVer.ufConselhoRegionalDescricao = EnumExtensions.getNameByValue(ufs, data.ufConselhoRegional);
            }

            this.modelVer.generoDescricao = EnumExtensions.getNameByValue(generoPessoa, data.genero);
            this.modelVer.estadoDescricao = EnumExtensions.getNameByValue(ufs, data.estadoId);
            this.showVer = true;
        } catch {}

        this.shortcutComponent.show();
    }
}
